// src/frontend/Utils/notifyError.js
import emailjs from "@emailjs/browser";

const EMAILJS_SERVICE_ID = "service_2sxefjt";
const EMAILJS_TEMPLATE_ID = "template_jqaxguj";
// must start with REACT_APP_ to be available in the browser bundle
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const notifyRenderError = async (
  e,
  status = "N/A",
  context = {}
) => {
  try {
    await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        // These names must match your EmailJS template variables
       serviceName:"Rosemount Website"
      },
      EMAILJS_PUBLIC_KEY
    );

    console.log("Error notification sent via EmailJS");
  } catch (notifyErr) {
    console.error("Failed to send error notification:", notifyErr);
  }
};

export default notifyRenderError;
